import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { BrandDto, FormFieldValuesDto, LeadFormDto, MetaPageDto, WebhookStatusDto } from '@shared/types';

/** Sdílené query klíče — používají je Leady, Stránky a formuláře, Šablony i Nastavení. */
export const brandsKey = ['brands'] as const;
export const metaPagesKey = ['meta-pages'] as const;
export const leadFormsKey = ['meta-forms'] as const;
export const webhookStatusKey = ['webhook-status'] as const;

export function useBrands() {
  return useQuery({
    queryKey: brandsKey,
    queryFn: () => api.get<BrandDto[]>('/brands'),
  });
}

export function useMetaPages() {
  return useQuery({
    queryKey: metaPagesKey,
    queryFn: () => api.get<MetaPageDto[]>('/meta/pages'),
  });
}

export function useLeadForms() {
  return useQuery({
    queryKey: leadFormsKey,
    queryFn: () => api.get<LeadFormDto[]>('/meta/forms'),
  });
}

/** Pole a odpovědi z posledních leadů formuláře — nápověda pro pravidla akcí. */
export function useFormFields(formId: string | null) {
  return useQuery({
    queryKey: ['meta-form-fields', formId],
    queryFn: () => api.get<FormFieldValuesDto>(`/meta/forms/${formId}/fields`),
    enabled: !!formId,
    staleTime: 60_000,
  });
}

export function useWebhookStatus() {
  return useQuery({
    queryKey: webhookStatusKey,
    queryFn: () => api.get<WebhookStatusDto>('/meta/webhook-status'),
  });
}
